import Header from "@/components/Header/Header.vue"

export default {
    name: 'Dashboard',
    components: {
        Header
    }
}
